var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProjectsTableHeaderGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.333.333H1.667C.933.333.333.933.333 1.667v10.666c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V1.667c0-.734-.6-1.334-1.334-1.334m-8 12H1.667V9.667h2.666zm0-4H1.667V5.667h2.666zm0-4H1.667V1.667h2.666zm4 8H5.667V9.667h2.666zm0-4H5.667V5.667h2.666zm0-4H5.667V1.667h2.666zm4 8H9.667V9.667h2.666zm0-4H9.667V5.667h2.666zm0-4H9.667V1.667h2.666z"
})));
export default SvgProjectsTableHeaderGrid;